import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ExternalLink, PlayCircle } from 'lucide-react';
import { InteriorSlide, SlideHeader } from './SlideShell';
import type { SlideProps } from './SlideShell';
const SNAK_URL = 'https://clarity.snakker.io/';
export function Slide03Background({
  index
}: SlideProps) {
  return <InteriorSlide data-id="element-83" data-mp="330x8ukoj997r">
      <SlideHeader eyebrow="Current Situation" data-id="element-84" data-mp="32y16mk5njydi">
        The established brands are digital-first, but the format needs to work
        harder
      </SlideHeader>

      <div className="flex-1 flex flex-col lg:flex-row items-center gap-12 lg:gap-20 max-w-6xl mx-auto w-full" data-id="element-85" data-mp="3bzqyts7cz1cc">
        {/* Left text content */}
        <div className="flex-1 space-y-8" data-id="element-86" data-mp="3gtv66ckjdbdy">
          {['The established brands are promoted 100% digitally.', 'GSK already uses digital channels such as email and WhatsApp.', 'Current assets are well-designed, but HCP engagement is declining across the portfolio.', 'The next opportunity is not simply more content, but a more engaging format.'].map((point, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.3 + i * 0.15,
          duration: 0.5
        }} className="flex items-start gap-4" data-id="element-87" data-mp="3dpr4m4ihvwk8" data-mpi={i}>
              <div className="mt-1.5 h-2 w-2 rounded-full bg-[var(--brand)] flex-shrink-0" data-id="element-88" data-mp="b4azycsgw3j" />
              <p className="text-[clamp(1.1rem,1.4vw,1.3rem)] text-[var(--fg)] font-medium leading-relaxed" data-id="element-89" data-mp="3rpa1g15uvlh8">
                {point}
              </p>
            </motion.div>)}
        </div>

        {/* Right visual comparison */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.6,
        duration: 0.7
      }} className="flex-1 w-full bg-[var(--surface)] rounded-3xl p-8 border border-black/5 flex flex-col items-center relative" data-id="element-90" data-mp="o29oi6v9bcao">
          <div className="absolute top-4 left-4 text-xs font-bold uppercase tracking-wider text-[var(--muted)]" data-id="element-91" data-mp="23q7x6ex971cr">
            From Passive
          </div>
          <div className="absolute top-4 right-4 text-xs font-bold uppercase tracking-wider text-[var(--brand)]" data-id="element-92" data-mp="1uqkvds0m3tj6">
            To Interactive
          </div>

          <div className="flex items-center justify-center w-full gap-6 mt-6" data-id="element-93" data-mp="1zocpmsoqbrqj">
            {/* Passive side */}
            <div className="w-64" data-id="element-94" data-mp="1ps9l5g6enh0f">
              <img src="https://cdn.magicpatterns.com/uploads/pYRAWESiLT3ffXuSTVNxqJ/Screenshot_2026-06-29_at_12.58.39.png" alt="Passive digital format example" className="w-full h-auto rounded-xl shadow-md border border-black/10" data-id="element-95" data-mp="1ptaxdnz5q9jq" />
            </div>

            {/* Arrow */}
            <div className="flex-shrink-0 text-[var(--brand-light)]" data-id="element-96" data-mp="18gulchnap8ya">
              <ArrowRight className="h-8 w-8" data-id="element-97" data-mp="13lp0lm5mq0bs" />
            </div>

            {/* Interactive side — opens the live Snak in a new tab */}
            <div className="w-48 relative" data-id="element-98" data-mp="1dia7kd17lli9">
              <div className="absolute -inset-4 bg-[var(--brand)]/10 rounded-3xl blur-xl" data-id="element-99" data-mp="1dh8tdzowciwb" />
              <a href={SNAK_URL} target="_blank" rel="noopener noreferrer" aria-label="Open the live Snak example in a new tab" className="group relative z-10 block w-full rounded-[2rem] focus:outline-none focus-visible:ring-4 focus-visible:ring-[var(--brand)]/40" data-id="element-100" data-mp="1r8neqd6a0w6j">
                <img src="https://cdn.magicpatterns.com/uploads/7abRhafkJdCwR9XYCAKe7C/Screenshot_2026-06-29_at_12.57.57.png" alt="Interactive Snakker format example" className="w-full h-auto rounded-[2rem] shadow-2xl border-4 border-white transition-transform group-hover:scale-[1.02]" data-id="element-101" data-mp="6ttu0hpac7um" />
                <span className="absolute inset-0 flex items-center justify-center rounded-[2rem] bg-[var(--fg)]/0 transition-colors group-hover:bg-[var(--fg)]/25" data-id="element-102" data-mp="89fovv09j968">
                  <span className="flex items-center gap-1.5 rounded-full bg-white px-3 py-1.5 text-xs font-bold text-[var(--brand)] opacity-0 shadow-lg transition-opacity group-hover:opacity-100" data-id="element-103" data-mp="i9gd9vczofha">
                    <PlayCircle className="h-4 w-4" data-id="element-104" data-mp="3lp3xuhu0piag" />
                    Open the Snak
                    <ExternalLink className="h-3.5 w-3.5" data-id="element-105" data-mp="3qp9qo1c0xau4" />
                  </span>
                </span>
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </InteriorSlide>;
}